module.exports = __webpack_public_path__ + "img/production.ff874a4e.png";